<script setup lang="ts">
import { BaseButton, Modal, Typography } from 'src/shared/ui';
import { useClientPublishDialogStore } from './model';
import { openDownload } from 'src/logic/functions/open-download.function';
import { computed } from 'vue';

const dialogStore = useClientPublishDialogStore();
const dialogZIndex = computed(() => Math.max(dialogStore.props?.zIndex ?? 70, 70));

const onConfirm = (): void => {
  dialogStore.props?.callback?.('6');
  dialogStore.onClose(true);
};

const onClose = (value: boolean): void => {
  if (!value) {
    dialogStore.onClose(false);
  }
};
</script>

<template>
  <Modal
    v-if="dialogStore.isOpen && dialogStore.props"
    :open="dialogStore.isOpen"
    :hide-close-icon="dialogStore.props?.hideCloseIcon"
    :max-width="dialogStore.props?.maxWidth"
    :z-index="dialogZIndex"
    :size="dialogStore.props?.size ?? 'm'"
    :close-on-click-outside="false"
    @update:open="onClose"
  >
    <template #title>
      <typography :variant="'h6'" as="p" class="title-text"> Данные внесены корректно? </typography>
    </template>
    <form>
      <div class="dialog-container">
        <typography :variant="'body-3'" as="p" class="description-text">
          Проверьте корректность внесённых данных, т.к. некоторые поля будут недоступны для
          редактирования после публикации.
        </typography>
        <typography :variant="'body-3'" as="p" class="description-text second">
          Нажимая кнопку <strong>Опубликовать</strong>, в соответствии с условиями
          <a
            class="agreements"
            href="/documents/user-agreement"
            @click.prevent="openDownload('/documents/user-agreement')"
            >Пользовательского соглашения</a>, Вы подтверждаете наличие согласия клиента (или его представителя) на хранение его
          персональных данных в Сервисе.
        </typography>
        <typography :variant="'body-3'" as="p" class="description-text third">
          Скачать шаблон
          <a
            class="agreements"
            href="/documents/pd-consent-client "
            @click.prevent="openDownload('/documents/pd-consent-client ')"
            >Согласия на обработку персональных данных</a>
          для клиента.
        </typography>
        <div class="modal-buttons">
          <BaseButton type="primary" size="xxl" class="modal-button" @click="onConfirm()">{{ dialogStore.props?.confirmButtonText || 'Подтвердить' }}
          </BaseButton>
          <BaseButton
            type="secondary"
            size="xxl"
            class="modal-button color-blue"
            @click="onClose(false)"
            >Отменить
          </BaseButton>
        </div>
      </div>
    </form>
  </Modal>
</template>

<style scoped src="./client-publish-dialog.css"></style>
